import { translate } from '../../../../shared/services/I18nService';
import us from '../../defines';

const i18Namespace = 'uScope.others.toolbar';

let $textEditPanel, $textEditForm, lastCursorPosition, lastCallback;

function createTextEditPanel (initialText) {
  const $t = translate.scope(i18Namespace);
  $textEditPanel = $('<div/>', { 'id': us.idTEXTEDITPANEL, 'class': us.clsPANEL });

  $textEditForm = $('<textarea />')
    .val(initialText)
    .css('resize', 'none')
    .width(us.textEditSpecs.width - 30)
    .height(us.textEditSpecs.height - 120);

  $textEditPanel.append($textEditForm);

  $textEditPanel.dialog({
    autoOpen: false,
    draggable: true,
    resizable: false,
    stack: true,
    modal: true,
    width: us.textEditSpecs.width,
    minWidth: us.textEditSpecs.width,
    height: us.textEditSpecs.height,
    minHeight: us.textEditSpecs.height,
    dialogClass: 'uscope-dialog dialogMover',
    closeText: $t('close'),
    buttons: [
      {
        text: $t('cancel'),
        click () {
          $textEditPanel.find('textarea').val(''); // clear text and close
          $textEditPanel.dialog('close');
        }
      },
      {
        text: $t('ok'),
        click () {
          var jtext = $textEditPanel.find('textarea');
          var outText = $(jtext).val();
          jtext.val(''); // clear text and close
          $textEditPanel.dialog('close');
          lastCallback(lastCursorPosition, outText);
        }
      }
    ],
    resize (event, ui) {
      // TODO: Is this function used?
      var w = $textEditPanel.width() - 10;
      var h = $textEditPanel.height() - 10;
      $textEditForm.width(w);
      $textEditForm.height(h);
    },
    // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
    // (would normally want it appended to the uscope div)
    appendTo: 'body'
  });
}

export function TextEditPanel (uScope) {
  return {
    openTextEditPanel (title, text, callback, cursorPosition) {
      if (!uScope.isThisImageValid()) {
        return;
      }

      text = text || '';
      if (!$textEditPanel) {
        createTextEditPanel(text);
      } else {
        $textEditForm.val(text);
      }

      lastCallback = (...args) => {
        callback && callback.apply(null, args);
      };
      lastCursorPosition = cursorPosition;
      $textEditPanel.dialog('option', 'title', title);

      $textEditPanel.dialog('open');
    }
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/text-edit-panel.js